import { render, staticRenderFns } from "./ModalCreateMenssages.vue?vue&type=template&id=4eacabe8&scoped=true"
import script from "./ModalCreateMenssages.vue?vue&type=script&lang=js"
export * from "./ModalCreateMenssages.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateMenssages.vue?vue&type=style&index=0&id=4eacabe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eacabe8",
  null
  
)

export default component.exports